import { Chart } from "primereact/chart";
import { useEffect, useState } from "react";
import GradeDistributionModal from "./gradeDistributionModal";
import ReactModal from "react-modal";
import { IStudentGradeDetail } from "../../../../models/student/studentGradeDetail";
import { setStudentGradeDetail } from "../../../../store/slices/student/studentGradeSlice";
import { connect, useDispatch } from "react-redux";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { getStudentGradeDetail } from "../../../../action/student/studentGradeDetailsActionCreator";

const GradeDistribution = (props: IStudentGradeDetail) => {
  const { getStudentGrade, studentGrade, userInfo } = props;
  const [chartData, setChartData] = useState({});
  const [showLarge, setShowLarge] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (userInfo && userInfo?.id) {
      getStudentGrade(userInfo?.id);
    }
  }, [userInfo?.id]);

  useEffect(() => {
    return () => {
      dispatch(setStudentGradeDetail([]));
    };
  }, []);

  useEffect(() => {
    if (studentGrade) {
      setChartData({
        labels: studentGrade?.map((student) => student.grade),
        datasets: [
          {
            data: studentGrade?.map((student) => student.percentage),
            backgroundColor : ["rgb(250, 151, 29)", "rgb(250, 115, 97)", "rgb(181, 82, 82)", "rgb(92, 126, 126)"],
            hoverOffset: 10,
          },
        ],
      });
    }
  }, [studentGrade]);

  const options = {
    cutout: "60%",
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          padding: 20,
        },
        onClick: null,
      },
      datalabels: {
        align: "center",
        color: "white",
        font: {
          weight: "bold",
          size: 14,
        },
        formatter: (value: number) => {
          return `${value}%`;
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem: any) {
            return tooltipItem.label;
          },
          title: function () {
            return "";
          },
        },
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "white",
        bodyColor: "white",
        displayColors: false,
        position: "average",
        caretPadding: 20,
        yAlign: "bottom",
      },
    },
    elements: {
      arc: {
        borderWidth: 2,
        borderColor: "white",
        borderRadius: 10,
      },
    },
  };

  const handleShow = () => setShowLarge(true);

  const handleClose = () => setShowLarge(false);

  return (
    <>
      <div className="card-wrap">
        <div className="title">
          <h2>Grade Distribution</h2>
          <a className="btn-link" onClick={handleShow}>
            Zoom In
          </a>
        </div>
        <div className="gardedistribution card p-1">
          <div id="chart-container">
            <Chart
              type="doughnut"
              data={chartData}
              options={options}
              className=""
              width="275"
              plugins={[ChartDataLabels]}
            />
          </div>
        </div>
      </div>
      <ReactModal
        isOpen={showLarge}
        onRequestClose={handleClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        style={{
          content: {
            width: "550px",
            outline: "none",
          },
        }}
      >
        <GradeDistributionModal
          showModal={handleClose}
          userInfo={userInfo}
          studentGrade={studentGrade}
        />
      </ReactModal>
    </>
  );
};

const mapDispatchToProps = {
  getStudentGrade: (studentId: string) => getStudentGradeDetail(studentId),
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
    studentGrade: state.studentGradeDetail.gradeDetail,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GradeDistribution);
